import React from 'react';
import './App.css';
import Inventions from './components/inventions.js'


function App() {
  return (
    <div>
        <Inventions />
    </div>
  );
}

export default App;

